import { useEffect, useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import { parameterList } from "./productList";
import { useAlert } from "react-alert";

const ProductItem = ({
  show,
  handleClose,
  selectedCard,
  setRecommendationData,
  isNewProduct,
  recommendationData,
  setIsNewProduct,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [isRecommended, setIsRecommended] = useState(false);
  const [productUrl, setProductUrl] = useState("");
  const [imageLink, setImageLink] = useState("");
  const [selectedLowParameters, setSelectedLowParameters] = useState([]);
  const [selectedHighParameters, setSelectedHighParameters] = useState([]);
  const alert = useAlert();

  useEffect(() => {
    setName(selectedCard.name || "");
    setDescription(selectedCard?.description || "");
    setIsRecommended(selectedCard.recommended ?? false);
    setProductUrl(selectedCard?.url || "");
    setImageLink(selectedCard?.icon || "");
  }, [selectedCard]);

  const handleParameterSelection = (type, value) => {
    if (type === "low") {
      setSelectedLowParameters(value);
    } else if (type === "high") {
      setSelectedHighParameters(value);
    }
  };

  const formatOptions = (options) => {
    return options.map((item) => ({
      key: item.toLowerCase(),
      text: item,
      value: item,
    }));
  };

  const addNewProduct = (currentProduct) => {
    setRecommendationData((prev) => [currentProduct, ...prev]);
    setIsNewProduct(false);
    handleClose();
    alert.info("Successfully added product");
  };

  const handleExistingProductChanges = () => {
    const modifiedProduct = recommendationData.map((each) => {
      if (each.id === selectedCard.id) {
        each.name = name;
        each.description = description;
        each.icon = imageLink;
        each.linked_tests.low = selectedLowParameters;
        each.linked_tests.high = selectedHighParameters;
        each.recommended = isRecommended;
        each.url = productUrl;
      }

      return each;
    });
    setRecommendationData(modifiedProduct);
    alert.info("Product details updated successfully.");
  };

  const handleSave = () => {
    let currentProduct = {
      id: selectedCard.id,
      name: name,
      description: description,
      icon: imageLink,
      linked_tests: {
        low: selectedLowParameters,
        high: selectedHighParameters,
      },
      recommended: isRecommended,
      url: productUrl,
    };

    if (isNewProduct) {
      addNewProduct(currentProduct);
    } else {
      handleExistingProductChanges();
    }

    handleClose();
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Product Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <InputGroup className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-default">
                Name
              </InputGroup.Text>
              <Form.Control
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </InputGroup>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Description</Form.Label>
              <Form.Control
                required
                as="textarea"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>
            <InputGroup className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-default">
                Product Image Link
              </InputGroup.Text>
              <Form.Control
                required
                value={imageLink}
                onChange={(e) => setImageLink(e.target.value)}
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-default">
                Product Link
              </InputGroup.Text>
              <Form.Control
                required
                value={productUrl}
                onChange={(e) => setProductUrl(e.target.value)}
              />
            </InputGroup>
            <div className="d-flex mb-3">
              <p className="me-3">Is Recommended</p>
              <Form>
                <Form.Check
                  inline
                  label="Yes"
                  name="recommendation"
                  type={"radio"}
                  className="me-3"
                  onChange={() => setIsRecommended(true)}
                  checked={isRecommended === true}
                />
                <Form.Check
                  inline
                  label="No"
                  name="recommendation"
                  type={"radio"}
                  onChange={() => setIsRecommended(false)}
                  checked={isRecommended === false}
                />
              </Form>
            </div>
            {isRecommended ? (
              <div>
                <div className="mb-4">
                  <p>Linked Tests for low values</p>
                  <Dropdown
                    placeholder="Select Parameters"
                    fluid
                    multiple
                    search
                    selection
                    options={formatOptions(parameterList)}
                    value={selectedLowParameters}
                    onChange={(e, data) =>
                      handleParameterSelection("low", data.value)
                    }
                  />
                </div>
                <div>
                  <p>Linked Tests for high values</p>
                  <Dropdown
                    placeholder="Select Parameters"
                    fluid
                    multiple
                    search
                    selection
                    options={formatOptions(parameterList)}
                    value={selectedHighParameters}
                    onChange={(e, data) =>
                      handleParameterSelection("high", data.value)
                    }
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            size="sm"
            onClick={() => handleSave(selectedCard.id)}
          >
            {isNewProduct ? "Add Product" : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProductItem;
